import { motion, AnimatePresence } from "framer-motion";

const SMOKE =
  "https://images.unsplash.com/photo-1630695230041-8909e3204778?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxtYWdpY2FsJTIwbWlzdCUyMGZvZyUyMGRhcmt8ZW58MHx8fHwxNzg4ODI2Nzk3fDA&ixlib=rb-4.1.0&q=85";

const LAYERS = [
  { rot: 0, dur: 1.9, hue: "0deg", scaleFrom: 0.6, scaleTo: 1.9 },
  { rot: 180, dur: 2.2, hue: "40deg", scaleFrom: 0.8, scaleTo: 2.2 },
  { rot: 90, dur: 2.5, hue: "-30deg", scaleFrom: 0.5, scaleTo: 1.6 },
];

const MistTransition = ({ active }) => (
  <AnimatePresence>
    {active && (
      <motion.div
        data-testid="mist-transition"
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[70] overflow-hidden bg-[#0D0726]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        {LAYERS.map((l, i) => (
          <motion.div
            key={i}
            className="absolute -inset-[20%] mix-blend-screen"
            style={{
              backgroundImage: `url(${SMOKE})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: `hue-rotate(${l.hue}) brightness(1.4)`,
              rotate: l.rot,
            }}
            initial={{ scale: l.scaleFrom, opacity: 0 }}
            animate={{ scale: l.scaleTo, opacity: [0, 0.95, 0.7] }}
            transition={{ duration: l.dur, ease: [0.22, 1, 0.36, 1] }}
          />
        ))}
        <motion.div
          className="absolute inset-0"
          style={{
            background: "radial-gradient(circle at 50% 50%, rgba(245,158,11,0.35) 0%, transparent 55%)",
          }}
          initial={{ opacity: 0, scale: 0.4 }}
          animate={{ opacity: [0, 1, 0.4], scale: 1.6 }}
          transition={{ duration: 1.8, ease: "easeOut" }}
        />
      </motion.div>
    )}
  </AnimatePresence>
);

export default MistTransition;
